function validate(text) {
  var pattern = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
  return pattern.test(text)
}

export default {
  validate
}



// WEBPACK FOOTER //
// ./src/services/url_validator.js